<template>
  <div>
    <v-card>
           <v-dialog
      content-class="artDialog"
      persistent
      v-model="dialogAvvisoInterventoStato"
      width="800"
    >
      <v-card>
        <v-toolbar dense  color="indigo">
          <v-toolbar-title class="white--text"
            >Avviso di modifiche</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-btn
          small
            
            @click="
              dialogAvvisoInterventoStato = false;
              closeRichiesta();
            "
            >
            <v-icon   color="success">mdi-check</v-icon>
            </v-btn
          >
          <v-spacer></v-spacer>
          <v-btn small  @click="dialogAvvisoInterventoStato = false">

           
<v-icon color="red" >mdi-window-close</v-icon>
          </v-btn>

        </v-toolbar>
        <v-card-text class="mt-6">
          <h3>vuoi modificare lo stato della richiesta in Respinto</h3>
        </v-card-text>
        <v-card-actions>
          
        </v-card-actions>
      </v-card>
    </v-dialog>
      <v-toolbar color="indigo" dense>
        <v-toolbar-title class="white--text"> Richieste Manutenzione </v-toolbar-title>

        <v-spacer></v-spacer>
        <v-spacer></v-spacer>

        <!-- Bottone di invio modifiche dello stato commessa -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              @click="openformDialog"
              v-on="on"
              v-bind="attrs"
              small
              class="mr-5"
            >
              <v-icon color="primary">mdi-plus</v-icon>
            </v-btn>
          </template>
          <span>Crea Richiesta</span>
        </v-tooltip>

       <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              @click="activateFilters"
              class="mr-4"
              small
              v-bind="attrs"
              v-on="on"
            >
              <v-icon color="purple"> mdi-filter </v-icon>
            </v-btn>
          </template>
          <span>{{this.show_filtri == false ? 'Show filters':'Hide filters'}}</span>
        </v-tooltip>

        
        <v-spacer></v-spacer>


        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn small @click="goBack" v-bind="attrs" v-on="on">
              <v-icon color="error"> mdi-keyboard-backspace </v-icon>
            </v-btn>
          </template>
          <span>Back</span>
        </v-tooltip>
      </v-toolbar>
      <v-card-text id="mainCardText" class="mt-3">
       <v-row align="center" justify="center" v-if="show_filtri">
          <v-col cols="4" md="2">
            <v-autocomplete
              background-color="#ffffff"
              @change="filtra"
              dense
              hide-details
              :items="items_pezzi_visualizzati"
              item-text="richiedente"
              item-value="richiedente"
              label="Richiedente"
              style="display: inline-block; max-width: 350px"
              v-model="richiedente_search"
            >
              <template v-slot:append>
                <v-icon
                  class="ml-2"
                  @click="
                    richiedente_search = '';
                    filtra();
                  "
                  color="primary"
                  >{{
                    richiedente_search == "" ? "mdi-filter" : "mdi-filter-off"
                  }}</v-icon
                >
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="4" md="2">
            <v-autocomplete
              background-color="#ffffff"
              @change="filtra"
              dense
              hide-details
              :items="items_pezzi_visualizzati"
              item-text="data"
              item-value="data"
              label="Data"
              style="display: inline-block; max-width: 350px"
              v-model="data_search"
            >
              <template v-slot:append>
                <v-icon
                  class="ml-2"
                  @click="
                    data_search = '';
                    filtra();
                  "
                  color="primary"
                  >{{
                    data_search == "" ? "mdi-filter" : "mdi-filter-off"
                  }}</v-icon
                >
              </template>
            </v-autocomplete>
          </v-col>
        
          <v-col cols="4" md="2">
            <v-autocomplete
              background-color="#ffffff"
              @change="filtra"
              dense
              hide-details
              :items="items_pezzi_visualizzati"
              item-text="des_oggetto"
              item-value="des_oggetto"
              label="Oggetto"
              style="display: inline-block; max-width: 350px"
              v-model="oggetto_search"
            >
              <template v-slot:append>
                <v-icon
                  class="ml-2"
                  @click="
                    oggetto_search = '';
                    filtra();
                  "
                  color="primary"
                  >{{
                    oggetto_search == "" ? "mdi-filter" : "mdi-filter-off"
                  }}</v-icon
                >
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="4" md="2">
            <v-autocomplete
              background-color="#ffffff"
              @change="filtra"
              dense
              hide-details
              :items="items_pezzi_visualizzati"
              item-text="des_ambito"
              item-value="des_ambito"
              label="Ambito Manu."
              style="display: inline-block; max-width: 350px"
              v-model="ambito_search"
            >
              <template v-slot:append>
                <v-icon
                  class="ml-2"
                  @click="
                    ambito_search = '';
                    filtra();
                  "
                  color="primary"
                  >{{
                    ambito_search == "" ? "mdi-filter" : "mdi-filter-off"
                  }}</v-icon
                >
              </template>
            </v-autocomplete>
          </v-col>
          <v-col cols="4" md="2">
            <v-autocomplete
              background-color="#ffffff"
              @change="filtra"
              dense
              hide-details
              :items="items_pezzi_visualizzati"
              item-text="des_stato"
              item-value="des_stato"
              label="Stato"
              style="display: inline-block; max-width: 350px"
              v-model="stato_search"
            >
              <template v-slot:append>
                <v-icon
                  class="ml-2"
                  @click="
                    stato_search = '';
                    filtra();
                  "
                  color="primary"
                  >{{
                    stato_search == ""
                      ? "mdi-filter"
                      : "mdi-filter-off"
                  }}</v-icon
                >
              </template>
            </v-autocomplete>
          </v-col>
         
        </v-row>
      </v-card-text>
        <v-data-table
          :loading="loading"
          :items="lista_tabella"
          :headers="headers_etichette"
          :single-expand="true"
          :expanded.sync="expanded"
      fixed-header
      item-key="id_richiesta"
      show-expand

        >
          <!-- Botton for updating Intervento -->
          <template v-slot:[`item.edit`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="updateRichiesta(item)"
                  small
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="primary"> mdi-pencil </v-icon>
                </v-btn>
              </template>
              <span>Modifica </span>
            </v-tooltip>
          </template>
        <template v-slot:[`item.des_stato`]="{ item }">
         
                <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                  <v-icon    
                  v-bind="attrs"
                  v-on="on" 
                  v-if="item.id_stato == 4" 
                  color="error"> mdi-close </v-icon>
              </template>
              <span>{{item.des_stato}} </span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                  <v-icon    
                  v-bind="attrs"
                  v-on="on"  v-if="item.id_stato == 1" color="primary"> mdi-wrench </v-icon>
              </template>
              <span>{{item.des_stato}} </span>
            </v-tooltip>
                        <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                  <v-icon    
                  v-bind="attrs"
                  v-on="on"  v-if="item.id_stato == 2" color="orange"> mdi-play-speed </v-icon>
                   </template>
              <span>{{item.des_stato}} </span>
            </v-tooltip>
             
                    <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                  <v-icon    
                  v-bind="attrs"
                  v-on="on" v-if="item.id_stato == 3" color="green">mdi-check</v-icon> 
                                     </template>
              <span>{{item.des_stato}} </span>
            </v-tooltip>
          </template>
          <!-- Botton for deleting the Intervento -->
          <template v-slot:[`item.delete`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="deleteRichiesta(item)"
                  small
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="error"> mdi-window-close </v-icon>
                </v-btn>
              </template>
              <span>Elimina</span>
            </v-tooltip>
          </template>

<template v-slot:expanded-item="{ headers,item }">

        <td
          class="pa-0"
          style="background-color: white"
          :colspan="headers.length"
        >
      
        <interventi-tabella
        :key="item.id_richiesta"
        :id_richiesta="item.id_richiesta"
        :listaInterventi="item.interventi"
        :id_ambito="item.id_ambito"
        tipo="ChildComponent"
        v-on:updateRichcomp="updateComponent($event)"
        v-on:setrichiestacomplete="completeRichiesta($event)"
        :id_oggetto="item.id_oggetto"
        :hideInterventoButtom="hideInterventoButtom"
        />
        </td>
</template>
        </v-data-table>
     

      <v-dialog persistent v-model="dialog_show" fullscreen width="80%">
        <v-card>
          <v-toolbar dense color="indigo" class="white--text">
            <v-toolbar-title>Richiesta</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  @click="salvaRichiesta"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="success"> mdi-floppy </v-icon>
                </v-btn>
              </template>
              <span>Salva</span>
            </v-tooltip>

            <v-tooltip v-if="sel_richiesta.id_richiesta > -1" bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  @click="dialogAvvisoInterventoStato = true"
                  v-bind="attrs"
                  v-on="on"
                  class="ml-2"
                >
                  <v-icon color="error"> mdi-receipt </v-icon>
                </v-btn>
              </template>
              <span>Repingi Richiesta</span>
            </v-tooltip>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="dialog_show = false"
                  v-bind="attrs"
                  v-on="on"
                  small
                >
                  <v-icon color="error">mdi-keyboard-backspace </v-icon>
                </v-btn>
              </template>
              <span>Close</span>
            </v-tooltip>
          </v-toolbar>
          <v-row align="center" class="px-2">
            <v-col class="mt-3" cols="3"
              ><v-text-field
                dense
                v-model="sel_richiesta.richiedente"
                label="Richiedente"
                placeholder="Richiedente"
              ></v-text-field
            ></v-col>
            <v-col cols="3" class="mt-3">
                <v-menu
                    v-model="menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="formatDateTempi"
                        label="Data"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        dense
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="data"
                      @input="menu = false"
                      locale="it"
                      :show-current="false"
                    ></v-date-picker>
                  </v-menu>

           
            </v-col>
            <v-col cols="3">
              
              <v-autocomplete
                v-model="sel_richiesta.id_ambito"
                :items="ambito_manu_list"
                item-text="des"
                label="Ambito Manutenzione"
                placeholder="Ambito Manutenzione"
                required
                item-value="id_tabella"
              >
                <template #label>
                  <span class="">Ambito Manutenzione</span>
                  <a @click.stop style="pointer-events: all">
                    <Modules
                      v-on:dialogModules="gettabelle"
                      tipo="INTERVENTI_AMBITO_MANU"
                      nome="Ambito Manutenzione"
                      setaction="settabelle"
                      getaction="gettabelle"
                      controller="Magazzino"
                      filter="validita = 1"
                      :dati="[{ des: '' }]"
                    />
                  </a>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="3">
              <v-autocomplete
                v-model="sel_richiesta.id_stato"
                :items="stato_list"
                item-text="des"
                label="Stato"
                placeholder="Stato"
                required
                item-value="id"
              >
             
              </v-autocomplete>
            </v-col>
             <v-col cols="3" lg="3" md="3" sm="3" class="py-0">
            <v-autocomplete
                    v-model="sel_richiesta.id_oggetto"
                    :items="macchinaList"
                    label="Oggetto"
                    :item-text="
                      (item) => `${item.des_macchina} - ${item.cod_macchina}`
                    "
                    placeholder="Des. Oggetto"
                    item-value="id_macchina"
                    required
                  >
                  </v-autocomplete>
            </v-col>
          </v-row>
          <v-card-subtitle>
            <v-tabs class="mt-5" v-model="tab_contenitore" align-with-title>
              <v-tabs-slider color="transparent"></v-tabs-slider>
              <v-tab
                active-class="py-0 my-0 indigo white--text"
                class="py-0 my-0"
                v-for="item in tabs_Interventi"
                :key="item"
              >
                {{ item }}
              </v-tab>
            </v-tabs>
          </v-card-subtitle>
          <v-card-text class="mt-4">
            <v-tabs-items v-model="tab_contenitore">
              <v-tab-item>
                 <v-card>
                 
                  <v-row align="center">
                    <v-col cols="12">
                     <v-textarea label="Problema" v-model="sel_richiesta.problema" placeholder="Problema"></v-textarea>
                    </v-col>
                     <v-col cols="12">
                     <v-textarea label="Soluzione Proposta" v-model="sel_richiesta.soluzione" placeholder="Soluzione Proposta"></v-textarea>
                    </v-col>
                  </v-row>
                </v-card>
              </v-tab-item>
              <v-tab-item>
               <GestioneAllegato
                  @click_chiudi="gestione_allegati_visible = false"
                  controller_allegati="Global"
                  controller_caratteristiche_tabella="Manutenzione"
                  :id_riferimento="sel_richiesta.id_richiesta"
                  :read_only="false"
                  ref="componenteAllegati"
                  :show_save_button="false"
                  @snackbarOpen="snackbarOpen"
                  tipo_allegato="QM_RICHIESTA"
                />
               
              </v-tab-item>
            </v-tabs-items>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- Snackbar -->
      <SnackbarQV ref="SnackbarQV" />
    </v-card>
  </div>
</template>
<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

import moment from "moment";
import GestioneAllegato from "../../TOOLS/GestioneAllegato.vue";
import InterventiTabella from '../Interventi/InterventiTabella.vue';
class Richiesta {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
      });
    } else {
      const campi = this.setCampi();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }

  // Metodo per resettare tutte le campi
  reset() {
    const campi = this.setCampi();

    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setCampi() {
    const campi = [
      { nome: "id_richiesta", default_val: -1 },
      { nome: "richiedente", default_val: "" },
      { nome: "id_ambito", default_val: null },
      { nome: "data", default_val: null },
      { nome: "id_oggetto", default_val: null },
      { nome: "id_stato", default_val: null },
      { nome: "des_stato", default_val: null },
      { nome: "problema", default_val: null },
      { nome: "soluzione", default_val: null },     
      { nome: "validita", default_val: 1 },
      { nome: "id_utente", default_val: null },
    ];

    return campi;
  }
}
export default {
  name: "",
  components: {
    SnackbarQV,
    GestioneAllegato,
    InterventiTabella,
    Modules: () => import("@/components/TOOLS/Modules"),

  },
  props: [
    "hideInterventoButtom"
  ],
  data() {
    return {
      // Variabili d'appoggio
      sel_richiesta: new Richiesta(),
      richiedente_search: "",
      data_search: "",
      oggetto_search: "",
      stato_search: "",
      ambito_search:"",
      data: "",
      menu: false,
      // Modal
      show_filtri: false,
      dialog_show: false,
      dialogAvvisoInterventoStato:false,
      loading: false,
      // Array
      expanded:[],
      tab_contenitore: [],
      lista_etichette: [],
      tipo_list: [
        {
          id:1,
          des:'Preventiva'
        },
         {
          id:2,
          des:'Incidentale'
        },
         {
          id:3,
          des:'Migliorativa'
        },
        {
          id:4,
          des:"Autonoma"
        }
      ],
      stato_list:[
        {
          id:1,
          des:"Aperto"
        },
                {
          id:2,
          des:"In Corso"
        },
                {
          id:3,
          des:"Completato"
        },
                {
          id:4,
          des:"Respinto"
        }
      ],
      lista_tabella: [],
      items_pezzi_visualizzati:[],
      listaInterventi:[],
      macchinaList:[],
      ambito_manu_list:[],
    
      headers_etichette: [
        {
          text: "",
          value: "edit",
          sortable: false,
        },
        {
          text: "Richiedente",
          value: "richiedente",
          sortable: true,
        },
        {
          text: "Data",
          value: "data",
          sortable: true,
        },
        {
          text: "Oggetto",
          value: "des_oggetto",
          sortable: true,
        },
        {
          text: "Ambito Manu.",
          value: "des_ambito",
          sortable: true,
        },

        {
          text: "Stato",
          value: "des_stato",
          sortable: true,
        },
 
        {
          text: "",
          value: "delete",
          sortable: false,
        },
      ],
      tabs_Interventi: ["Dettaglio","Allegati"],
    };
  },
  methods: {
    completeRichiesta(val){
       if (val > -1) {
         let i = this.lista_tabella.findIndex(it=>it.id_richiesta === val)
         this.sel_richiesta = new Richiesta(this.lista_tabella[i]);
         this.sel_richiesta.id_stato = 3 
         this.sel_richiesta.data = moment(this.sel_richiesta.data).format("YYYY-MM-DD")
         this.salvaRichiesta();
       }
    },
    closeRichiesta(){
      this.sel_richiesta.id_stato = 4;
      this.sel_richiesta.data = moment(this.sel_richiesta.data).format("YYYY-MM-DD");
      this.salvaRichiesta();
    },
     updateComponent  (val) {
      this.getRichieste();
       if (val === true) {
         console.log('true case :>> ');
         this.getRichieste();
       }
        if (val != true) {
         console.log('false case :>> ');

            this.loading = true;
      this.lista_etichette = [];
      this.lista_tabella = [];
      const request = {
        controller: "Manutenzione",
        method: "POST",
        richiesta: {
          action: "getrichiesteqm",
          token: localStorage.user_token,
          id_richiesta: "",
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          
          if (res.status === 200) {
               let temp_array =  res.data.richieste.reverse()
            
            for (let index = 0; index < temp_array.length; index++) {
                const element = temp_array[index];
                element.data = moment(element.data).format("DD/MM/YYYY")
                if (element.id_richiesta === val) {
                  if (element.interventi.length === 1) {
                  this.sel_richiesta = new Richiesta(element);
                   this.sel_richiesta.id_stato = 2;
                   this.sel_richiesta.data = moment(this.sel_richiesta.data).format("YYYY-MM-DD")
                   this.salvaRichiesta();
                  }
                }
            }
   
 
            
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              `Criticità rilevata, codice stato: ${res.status}.`
            );
            this.loading = false;
          }
        })
        .catch((err) => {
          this.$refs.SnackbarQV.print(
            "error",
            `${JSON.parse(err.response.data.message).result}.`
          );
        });
        
         
         
        }
    },
    
    activateFilters(){
      if (this.show_filtri) {
        this.show_filtri = false;
        
        this.resetFiltro();
      }else{
        this.show_filtri = true;
      }
        
    },
   
 
    snackbarOpen() {
      this.$refs.SnackbarQV.print(
        "orange",
        `Aggiungere ad ogni Allegato dell'attività una descrizione.`
      );
    },
    openformDialog() {
      this.sel_richiesta = new Richiesta();
      this.sel_richiesta.id_stato = 1;
      
      this.dialog_show = true;
      this.data= moment().format("YYYY-MM-DD");
      this.$refs.componenteAllegati.lista_allegati = [];
    },
    updateRichiesta(item) {
      this.sel_richiesta = new Richiesta(item);
      if (item.data != null && item.data != "") {
        this.data = moment(item.data, ["DD/MM/YYYY"]).format("YYYY-MM-DD");
      } else{
        this.data = undefined
      }
      this.dialog_show = true;
      this.loadingAvvisi = true;
    },
    salvaRichiesta() {
       if (this.sel_richiesta.richiedente === null || this.sel_richiesta.richiedente === '') {
        this.$refs.SnackbarQV.print(
              "orange",
              `il richiedente è vuoto`
            );
            return
      }
      this.sel_richiesta.id_utente = localStorage.id;
      let i = this.stato_list.findIndex(it=>it.id == this.sel_richiesta.id_stato);
      this.sel_richiesta.des_stato = this.stato_list[i].des;
      this.sel_richiesta.data = this.data;

 
      const request = {
        controller: "Manutenzione",
        method: "PUT",
        richiesta: {
          action: "setrichiestaqm",
          token: localStorage.user_token,
          id_richiesta: this.sel_richiesta.id_richiesta,
          data: [this.sel_richiesta],
        },
      };

      this.$store
        .dispatch("api", request)
        .then(async (res) => {
          if (res.status === 200) {
            this.$refs.SnackbarQV.print(
                  "success",
                  `Salvataggio avvenuto con successo`
                );
            if (this.$refs.componenteAllegati) {
              this.$refs.componenteAllegati.id_riferimento_creazione_genitore =
                res.data.result.split(",")[1];
              let resSalvataggio =
                await this.$refs.componenteAllegati.salvaTuttiAllegati();

              if (resSalvataggio) {
                this.$refs.SnackbarQV.print(
                  "success",
                  `Salvataggio avvenuto con successo`
                );

                this.$refs.componenteAllegati.lista_allegati = [];
              } else {
                this.$refs.SnackbarQV.print(
                  "orange",
                  `Aggiungere una descrizione per ogni Allegato.`
                );
              }
            }
            this.getRichieste();
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              `Criticità rilevata, codice stato: ${res.status}.`
            );
          }
        })
        .catch((err) => {
          this.$refs.SnackbarQV.print(
            "error",
            `${JSON.parse(err.response.data.message).result}.`
          );
        });
      this.dialog_show = false;
      this.sel_richiesta.id_richiesta = -1;
    },

    deleteRichiesta(item) {
      console.log(item);
      let data = item;
      item.id_utente = localStorage.id;
      data.validita = 0;
      const request = {
        controller: "Manutenzione",
        method: "PUT",
        richiesta: {
          action: "setrichiestaqm",
          token: localStorage.user_token,
          id_richiesta: this.sel_richiesta.id_richiesta,
          data: [data],
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        if (res.status === 200) {
          this.getRichieste();
        } else {
          this.$refs.SnackbarQV.print(
            "orange",
            `Criticità rilevata, codice stato: ${res.status}.`
          );
          this.loading = false;
        }
      });
      let i = this.lista_tabella.indexOf(item);
      this.lista_tabella.splice(i, 1);
    },
   
    getRichieste() {
      this.loading = true;
      this.lista_etichette = [];
      this.lista_tabella = [];
      const request = {
        controller: "Manutenzione",
        method: "POST",
        richiesta: {
          action: "getrichiesteqm",
          token: localStorage.user_token,
          id_richiesta: "",
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          
          if (res.status === 200) {
            res.data.richieste.sort();
            this.lista_etichette = res.data.richieste;
            this.lista_etichette.reverse();
            for (let index = 0; index < this.lista_etichette.length; index++) {
                const element = this.lista_etichette[index];
                if (element.data != null) {
                  element.data = moment(element.data).format("DD/MM/YYYY")
                }else{
                  element.data = "";
                }
                  
            }
  
            this.lista_tabella = this.lista_etichette;
            this.items_pezzi_visualizzati = this.lista_tabella;
            if (this.hideInterventoButtom) {
              let user_id = localStorage.getItem('id');
              let newArray = this.lista_etichette.filter(it=>it.id_utente === parseInt(user_id))
              this.lista_etichette = newArray;
              this.lista_tabella = newArray;
              this.items_pezzi_visualizzati = this.lista_tabella;
            }
            this.loading = false;
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              `Criticità rilevata, codice stato: ${res.status}.`
            );
            this.loading = false;
          }
        })
        .catch((err) => {
          this.$refs.SnackbarQV.print(
            "error",
            `${JSON.parse(err.response.data.message).result}.`
          );
        });
    },
    goBack() {
       if (this.hideInterventoButtom) {
        this.$emit("dialogClose")
      }else{
      this.$router.push("/home/quickmaintenance");
      }
    },
   
    filtra() {
      let items_etichette_tmp = [];
      this.lista_etichette.forEach((elem) => {
        items_etichette_tmp.push(elem);
      });

      // Filtro il nome della intervento
      if (this.richiedente_search != "" && this.richiedente_search != null) {
        // Faccio un array temporaneo
        const res = [];
        if (this.richiedente_search == "*") {
          this.lista_tabella = this.lista_etichette;
          return;
        }
        /* Filtro gli elementi visualizzati dopo i passaggi precedenti
         * e li inserisco in "res". */
        items_etichette_tmp.filter((elem) => {
          if (
            elem.richiedente.toLowerCase().includes(this.richiedente_search.toLowerCase())
          ) {
            res.push(elem);
          }
        });
        // Modello la risposta provvisoria su "res".
        items_etichette_tmp = res;
      }

      if (this.data_search != "" && this.data_search != null) {
        // Faccio un array temporaneo
        const res = [];
        /* Filtro gli elementi visualizzati dopo i passaggi precedenti
         * e li inserisco in "res". */
        items_etichette_tmp.filter((elem) => {
          if (
            elem.data
              .toLowerCase()
              .includes(this.data_search.toLowerCase())
          ) {
            res.push(elem);
          }
        });
        // Modello la risposta provvisoria su "res".
        items_etichette_tmp = res;
      }
      if (
        this.oggetto_search != "" &&
        this.oggetto_search != null
      ) {
        // Faccio un array temporaneo
        const res = [];
        /* Filtro gli elementi visualizzati dopo i passaggi precedenti
         * e li inserisco in "res". */
        items_etichette_tmp.filter((elem) => {
          if (
            elem.des_oggetto
              .toLowerCase()
              .includes(this.oggetto_search.toLowerCase())
          ) {
            res.push(elem);
          }
        });

        // Modello la risposta provvisoria su "res".
        items_etichette_tmp = res;
      }
      
       if (
        this.ambito_search != "" &&
        this.ambito_search != null
      ) {
        // Faccio un array temporaneo
        const res = [];
        /* Filtro gli elementi visualizzati dopo i passaggi precedenti
         * e li inserisco in "res". */
        items_etichette_tmp.filter((elem) => {
          if (
            elem.des_ambito
              .toLowerCase()
              .includes(this.ambito_search.toLowerCase())
          ) {
            res.push(elem);
          }
        });

        // Modello la risposta provvisoria su "res".
        items_etichette_tmp = res;
      }

      if (this.stato_search != "" && this.stato_search != null) {
        // Faccio un array temporaneo
        const res = [];
        /* Filtro gli elementi visualizzati dopo i passaggi precedenti
         * e li inserisco in "res". */
        items_etichette_tmp.forEach((elem) => {
          if (elem.des_stato == this.stato_search) {
            res.push(elem);
          }
        });
        // Modello la risposta provvisoria su "res".
        items_etichette_tmp = res;
      }
    
      this.lista_tabella = items_etichette_tmp;
    },
    resetTable() {
      this.richiedente_search = "";
      this.data_search = "";
      this.oggetto_search = "";
      this.stato_search = "";
      this.ambito_search="";
      this.lista_tabella = this.lista_etichette;
    },
    resetFiltro() {
      // Resetto i filtri
      this.richiedente_search = "";
      this.data_search = "";
      this.oggetto_search = "";
      this.stato_search = "";
      this.ambito_search="";
      // Nascondo i filtri
      this.show_filtri = false;

      this.lista_tabella = this.lista_etichette;
    },
     gettabelle() {
      // TO populate the list of select fields
      let req_data = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "gettabelle",
          token: localStorage.getItem("user_token"),
          tipo: "'TIPO_MANUTENZIONE','INTERVENTI_AMBITO_MANU'",
          filter: "validita = 1",
        },
      };
      this.$store.dispatch("api", req_data).then((res) => {
       this.ambito_manu_list = res.data.INTERVENTI_AMBITO_MANU
      });
    },
  },
  created() {},
  computed: {
     formatDateTempi() {
      return this.data != null && this.data != ""
        ? moment(this.data).format("DD/MM/YYYY")
        : undefined;
    },
  },
  mounted() {
    this.getRichieste();
    this.lista_etichette = this.lista_tabella;
    this.lista_tabella = this.lista_etichette;
    this.gettabelle();
      let manu_detail = {
      controller: "Manutenzione",
      method: "POST",
      richiesta: {
        action: "getlistamacchine",
        token: localStorage.getItem("user_token"),
      },
    };
    this.$store.dispatch("api", manu_detail).then((res) => {
      let macchinaData = res.data.macchine;
      macchinaData.filter((it) => {
        const updateobject = {};
        updateobject.id_macchina = it.id_macchina;
        updateobject.des_macchina = it.des_macchina;
        updateobject.cod_macchina = it.cod_macchina;
        this.macchinaList.push(updateobject);
        return this.macchinaList;
      });
    });
  },
  watch: {
    
    'this.sel_richiesta.data'(val) {
        
      let value = moment(val, "YYYY-MM-DD").format("DD/MM/YYYY");
    

      if (val !== "") {
        let items_etichette_tmp = [];
        this.lista_etichette.forEach((elem) => {
          items_etichette_tmp.push(elem);
        });

        // Faccio un array temporaneo

        const res = [];
        /* Filtro gli elementi visualizzati dopo i passaggi precedenti
         * e li inserisco in "res". */
        items_etichette_tmp.filter((elem) => {
          if (elem.consegna == value) {
            res.push(elem);
          }
        });

        // Modello la risposta provvisoria su "res".
        items_etichette_tmp = res;
        this.lista_tabella = items_etichette_tmp;
      }
    },
  },
};
</script>
<style scoped>
.sfondoStandard {
  background: linear-gradient(
    90deg,
    rgba(63, 81, 181, 1) 0%,
    rgba(63, 81, 181, 1) 100%
  );
}
</style>